import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { asChakraVariable } from '@mangovoice/design-system'

const CustomTooltipParts = ['container'] as const

const helpers = createMultiStyleConfigHelpers(CustomTooltipParts)
export const CustomTooltipStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      backgroundColor: 'bg.panel',
      borderRadius: '0.375rem',
      padding: '1rem',
      border: '1px solid',
      borderColor: 'border.muted',
      boxShadow: asChakraVariable('shadows.default'),
    },
  },
})

export const useCustomTooltipStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(CustomTooltipStyle, props) as MultiStyleType<
    typeof CustomTooltipParts
  >
}
